import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiPhone, FiMail } from "react-icons/fi";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();
  const [highlightFollow, setHighlightFollow] = useState(false);

  return (
  <footer className="bg-gradient-to-r from-black via-black to-[#111] text-gray-300 py-10 mt-auto border-t border-[#d4af37]/20">
    <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">

      {/* Company Info */}
      <div>
        <h2 className="text-xl font-bold text-[#D4AF37] mt-16">
          Codex Future Technologies Pvt. Ltd.
        </h2>
        <p className="text-sm leading-relaxed text-gray-400">
          Providing innovative IT solutions to businesses worldwide.
          <br /> Your success is our priority.
        </p>
      </div>

      {/* Quick Links */}
      <div>
        <h3 className="text-lg font-semibold text-[#D4AF37] mb-4">
          Quick Links
        </h3>
        <ul className="space-y-2">
          <li>
            <button
              onClick={() => navigate("/about")}
              className="hover:text-[#D4AF37] transition-colors duration-300"
            >
              About Us
            </button>
          </li>
          <li>
            <button
              onClick={() => navigate("/services")}
              className="hover:text-[#D4AF37] transition-colors duration-300"
            >
              Services
            </button>
          </li>
          <li>
            <button
              onClick={() => navigate("/contact")}
              className="hover:text-[#D4AF37] transition-colors duration-300"
            >
              Contact Us
            </button>
          </li>
        </ul>
      </div>

      {/* Social Media & Contact */}
      <div
        className={`transition-all duration-500 p-4 rounded-lg ${
          highlightFollow ? "bg-[#D4AF3715] shadow-lg shadow-[#D4AF3725]" : ""
        }`}
      >
        <h3 className="text-lg font-semibold text-[#D4AF37] mb-4">
          Follow Us
        </h3>

        {/* Social Icons */}
        <div className="flex flex-wrap gap-5 mb-6 text-2xl text-gray-300">
          <a href="tel:+919303715744" className="hover:text-green-400 transition-colors">
            <FiPhone />
          </a>
          <a href="mailto:codexfuturetechnologies@gmail.com" className="hover:text-red-400 transition-colors">
            <FiMail />
          </a>
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500">
            <FaFacebookF />
          </a>
         <a
            href="https://www.instagram.com/codex_future_tech_official/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-pink-500"
          >
           <FaInstagram />
          </a>
          <a
            href="https://www.linkedin.com/company/codex-future-technologies/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-300"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://wa.me/919303715744"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-green-300"
          >
            <FaWhatsapp />
          </a>
        </div>

        {/* Contact Info */}
        <div className="space-y-2 text-base leading-relaxed">
          <p className="text-gray-300">
            <span className="font-semibold text-[#D4AF37]">Phone:</span> +91 9303715744
          </p>
          <p className="text-gray-300">
            <span className="font-semibold text-[#D4AF37]">Address:</span>{" "}
            313-14, Shagun Arcade, Vijay Nagar Square, Indore, 452010
          </p>
        </div>
      </div>
    </div>

    {/* Footer Bottom */}
    <div className="mt-12 border-t border-[#d4af37]/20 pt-6 text-center text-sm text-gray-500">
      © 2025 Codex Future Technologies Pvt. Ltd. All rights reserved.
    </div>
  </footer>
);

};

export default Footer;
